import React, { useState, useEffect } from 'react'
import Select from 'component/Select/Select'
import PropTypes from 'prop-types'
import Api from 'utils/ApiRequest'
import API_URL from 'constants/api'
import { arraysEqual } from 'utils/validations'
import { isEqual } from 'lodash'

const StoreSelect = ({ onChange, user, translate, value, disabled, excludeInactive }) => {
  const [companies, setCompanies] = useState([])
  const [loading, setLoading] = useState(false)

  const mapCompanies = (company) => ({
    value: [company.id],
    label: `${company.id} - ${company.name}`,
  })

  const mapAll = (company) => company.id

  useEffect(() => {
  
    const fetchCompanies = async () => {
      setLoading(true)

      const endpoint = excludeInactive ? `${API_URL.BRANCHES}?excludeInactive=true` : API_URL.BRANCHES
      await new Api(user.dsToken)
        .post(endpoint)
        .then((response) => {
          response.data.push({
            id: '0999',
            name: translate('analytics.matrix.name'),
          })
          setCompanies([
            {
              label: translate('mobile.update.all.stores'),
              value: response.data.map(mapAll),
            },
            ...response.data.map(mapCompanies),
          ])
        })
        .catch(() => setCompanies([]))
        .finally(() => setLoading(false))
    }

    fetchCompanies()
  }, [])

  const placeholder = loading
    ? translate('loading')
    : translate('mobile.update.create.release.store.select')

  return (
    <Select
      label={translate('mobile.update.create.release.store')}
      options={companies}
      placeholder={placeholder}
      translate={translate}
      onChange={onChange}
      value={companies.find((option) => arraysEqual(option.value, value)) || value && companies.find((option) => isEqual(option.label.substring(0,4),value))}
      required
      validateValue={(v) => Boolean(v)}
      containerClass='text-align-left-no-color margin-top'
      fill
      disabled={disabled}
    />
  )
}

StoreSelect.propTypes = {
  onChange: PropTypes.func.isRequired,
  user: PropTypes.object,
  translate: PropTypes.func.isRequired,
  value: PropTypes.string,
  disabled: PropTypes.bool,
  excludeInactive: PropTypes.bool,
}

export default StoreSelect
